import {createSlice} from "@reduxjs/toolkit";

interface IInitState {
    query: string | undefined | null
    visit_date: boolean | undefined | 'all'
    page:number | undefined

}

const initialState: IInitState = {
    query: undefined,
    visit_date: undefined,
    page:1,
}

const appointmentReducer = createSlice({
    name: 'appointment',
    reducers: {
        setAppointmentFilterData: (state, {payload}) => {
            if (payload.query || payload.query === '') {
                state.query = payload.query
            }
            if (payload.visit_date || payload.visit_date !== 'all') {
                state.visit_date = payload.visit_date
            }

            if (payload.visit_date === 'all') {
                state.visit_date = undefined
            }
            if (payload.query === '') {
                state.query = undefined
            }
            if (payload.page||payload.page===undefined) {
                state.page = payload.page
            }

        },
        clearQueryAppointmentFilterData: (state) => {
            state.query = undefined
            state.visit_date = undefined
            state.page = undefined
        },
        clearQueryAppointmentQuery: (state) => {
            state.query = undefined
            state.visit_date = undefined
        }
    },
    initialState,

})

export const {clearQueryAppointmentFilterData, setAppointmentFilterData,clearQueryAppointmentQuery} = appointmentReducer.actions
export default appointmentReducer.reducer
